<template>
    <div>
        <Modal id="participantes" :open="show" :size="'modal-xl'" customSizeWid="" :FooterDefault="false" :ClassBG="true" customModalBody="" :customModalMain="'z-index:1051'">
            <template v-slot:header>
                <h6 class="modal-title">Participantes</h6>
                <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">
                    <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
                </button>
            </template>
            <template v-slot:body>
                <fieldset>
                    <div class="col-12">
                        <label class="form-label" style="color: #AB0000">Dados da Inscrição</label>
                        <Card_Title :class_color="'bg-color-4'">
                            <template v-slot:context>
                                <div>
                                    <div class="row">
                                        <div class="col-8">
                                            <label class="form-label">Localizador</label>
                                            <h5 class="card-dados" style="font-size:14px;">
                                                {{InscricaoCrud.inscricao.cdLocalizador}}
                                            </h5>
                                        </div>
                                        <div class="col">
                                            <label class="form-label"> Quantidade de Participantes</label>
                                            <h5 class="card-dados" style="font-size:14px;">
                                                <template v-if="InscricaoCrud.inscricao.qtdParticipantesOrigem == null">
                                                    {{InscricaoCrud.inscricao.qtdParticipantes}}
                                                </template>
                                                <template v-else>
                                                    {{InscricaoCrud.inscricao.qtdParticipantesOrigem}}
                                                </template>
                                            </h5>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-8">
                                            <label class="form-label">Nome do Responsável</label>
                                            <h5 class="card-dados" style="font-size:14px;">
                                                {{InscricaoCrud.inscricao.nmNomeResponsavel}}
                                            </h5>
                                        </div>
                                        <div class="col">
                                            <label class="form-label"> E-mail do Responsável</label>
                                            <h5 class="card-dados" style="font-size:14px;">
                                                {{InscricaoCrud.inscricao.dsEmailResponsavel}}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </Card_Title>
                    </div>

                    <div class="row mt-3" v-if="InscricaoCrud.inscricao.idOcorrencia > 0">
                        <div class="col-6">
                            <Card_Title :class_color="'bg-color-4'">
                                <template v-slot:context>
                                    <div>
                                        <div class="d-flex">
                                            <div>
                                                <label class="form-label">Ticket</label>
                                                <div class="d-flex flex-row mb-3">
                                                    <div class="mt-2">
                                                        <select id="select-consultor" :class="'form-select ' + verificaPermissaoSelect()" @change="atualizaConsultor" v-model="InscricaoCrud.dsLoginConsultor">
                                                            <option selected value="">Sem Consultor</option>
                                                            <option v-for="consultor in equipe" :key="consultor.nmUsuario" :value="consultor.dsLogin">
                                                                {{ consultor.nmUsuario }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div>
                                                        <button class="btn-grid-editar-lista ms-1" style="width: max-content;height: 35px; margin-top:8px" type="button" v-on:click="abreOcorrencia(InscricaoCrud.inscricao.idOcorrencia)"><i class="fas fa-eye"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </Card_Title>
                        </div>
                    </div>

                    <div class="row mt-3" v-else>
                        <div class="col-6">
                            <Card_Title :class_color="'bg-color-4'">
                                <template v-slot:context>
                                    <div>
                                        <div class="d-flex">
                                            <div>
                                                <label class="form-label">Ticket</label>
                                                <div>
                                                    <span>Nenhum</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </Card_Title>
                        </div>
                    </div>

                    <!--<div class="row mt-3" v-else>
        <div class="col-6">
            <Card_Title :class_color="'bg-color-4'">
                <template v-slot:context>
                    <div>
                        <div class="d-flex">
                            <div>
                                <label class="form-label">Ticket</label>
                                <div>
                                    <button class="btn-grid-editar-lista ms-1" style="width: max-content;height: 35px; margin-top:8px" type="button" v-on:click="GeraOcorrencia(InscricaoCrud.inscricao.idInscricao)"><i class="fas fa-plus"></i> Criar Ticket</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </Card_Title>
        </div>
    </div>-->

                </fieldset>
                <ListaParticipantes :show="refresh_grid" :idEvento="idEvento" :idInscricao="idInscricao" :filtro_text="''" class="mt-4"></ListaParticipantes>
            </template>
            <template v-slot:footer>
                <div class="modal-footer">
                </div>
            </template>
        </Modal>

        <modal-warper target="ModalTicket_2" :show="isOpenModalOcorrencia" @close="(isOpenModalOcorrencia = false)">
            <Ocorrencia :id="'ModalTicket_2'" :p_exibir="isOpenModalOcorrencia" :p_idModulo="idModulo" :p_idOcorrencia="p_idOcorrencia" :p_cdOcorrenciaTab="17" @fecharModal="fechou" ></Ocorrencia>
        </modal-warper>

    </div>
</template>

<script>

    import ListaParticipantes from '@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/Modais/Components/ListaParticipantes.vue'

    import Modal from "@/components/App/Modal.vue";
    import axios from "axios";
    import moment from "moment";
    import $ from "jquery";
    import Card_Title from '@/components/App/Card_Title.vue';
    import Ocorrencia from "@/views/Modais/Ocorrencia/Ocorrencia.vue";

    export default {
        name: "Participantes",
        components: {
            Modal, ListaParticipantes, Card_Title, Ocorrencia
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            idModulo: {
                type: Number,
                default: 0
            },
            idEvento: {
                type: Number,
                default: 0
            },
            idInscricao: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                isOpenModalOcorrencia: false,
                InscricaoCrud: {
                    inscricao: { idOcorrencia: 0 }
                },
                refresh_grid: false,
                filtro: [{ active: true }],
                permissoes: { flAdministrador: 'Não', flGestorNovos: 'Não' },
                ocorrencia: { idOcorrencia: 0, dsLoginConsultor: '' },
                p_idOcorrencia: 0
            };
        },
        methods: {
            //GeraOcorrencia(_idInscricao) {                
            //    let $this = this;

            //    var content = { idInscricao: _idInscricao };

            //    axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Inscricao/GeraOcorrencia', content, { headers: $this.$api.getTokenEventos() })
            //        .then(function (response) {
            //            $this.GetInscricao();
            //        })
            //        .catch(function (error) {
            //            var msg = 'Ocorreu um erro inesperado';
            //            if (error.response) {
            //                if (error.response.data.erros != '') {
            //                    msg = error.response.data.errors[0];
            //                } else {
            //                    msg = error.response.data.msg;
            //                }
            //            }
            //            $this.$toast.show('alert', msg, true);
            //        });
            //},
            atualizaConsultor() {
                let $this = this;

                var content = { idOcorrencia: $this.InscricaoCrud.inscricao.idOcorrencia, dsLogin: $this.InscricaoCrud.dsLoginConsultor };

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/OcorrenciaConsultor/Post', content, { headers: $this.$api.getTokenComercial() })
                    .then(function (response) {
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.$toast.show('alert', msg, true);
                    });
            },
            fechou() {
                this.isOpenModalOcorrencia = false;
            },
            abreOcorrencia(_idOcorrencia) {
                this.p_idOcorrencia = _idOcorrencia;
                this.isOpenModalOcorrencia = true;
            },
            getEquipeModulo() {
                let $this = this;
                var setor = 'Eventos'
                axios
                    .get(
                        process.env.VUE_APP_ROOT_COMERCIAL_API + "/Equipe/GetEquipeUsuario?idModulo=" + $this.idModulo + '&setor=' + setor, { headers: $this.$api.getTokenComercial(), })
                    .then((response) => {
                        $this.equipe = response.data.data;
                        $this.getPermissoesUsuario();
                    });
            },
            getPermissoesUsuario() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Equipe/GetPermissoesUsuarioModulo?idModulo=' + $this.idModulo, {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.permissoes = response.data.data;
                })
            },
            verificaPermissao() {
                if (this.permissoes.flAdministrador === 'Sim' || this.permissoes.flGestorNovos === 'Sim') {
                    return true;
                }
                else {
                    return false;
                }
            },
            verificaPermissaoSelect() {
                if (this.verificaPermissao()) {
                    return '';
                }
                else {
                    return 'select-block';
                }
            },
            GetInscricao() {
                let $this = this;

                axios.get(
                    process.env.VUE_APP_ROOT_EVENTOS_API + "/Inscricao/GetModalInscricao?idInscricao=" + $this.idInscricao,
                    {
                        headers: $this.$api.getTokenEventos(),                        
                        notLoading: false
                    }
                ).then((response) => {
                    $this.InscricaoCrud = response.data.data;
                    $this.getEquipeModulo();                
                });
            },
            getFiltros() {
                let $this = this;
                this.filtered = "";
                this.showFilters = false;
                this.noShadow = false;
                this.haveShadow = 'shadow-v2';
                this.reloadGrid();
            },
            clearFiltros() {
                this.filtros_Crud = {
                    cdLocalizador: "",
                    nmNome: "",
                };
                $("input[type=text]").val("");

                setTimeout(() => {
                    $("input[type=text]").val("");
                }, 200);

                this.filtered = "";
            },
            performSearch() {
            },
            getFormattedDate(date) {
                return moment(date).format("DD/MM/YYYY");
            },
            reloadGrid() {
                let $this = this;
                $this.refresh_grid = !$this.refresh_grid;
            },
        },
        mounted() { },
        watch: {
            show(n, o) {                
                this.GetInscricao();
                this.getFiltros();                
            },
        },
    };

</script>


<style scoped lang="scss">    

    .bold {
        font-weight: 500;
    }

    .d-flex-tabs {
        margin-right: 10px;
        margin-left: 10px;
    }

    .backdrop {
        height: calc(100vh - 3.8rem);
    }


    .customSelect .vue-select {
        height: 34px !important;
        display: flex !important;
        align-items: center !important;
        padding: 2px 10px !important;
    }


    .btn-aplicar-filter {
        width: 250px;
        height: 35px;
        background: #9f3029;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border: 1px solid #9f2d39;
        border-radius: 5px;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 140.62%;
        align-items: center;
        text-align: center;
        color: #ffffff;
    }

    .filled {
        border: 1px solid #299f4a;
    }

    .btn-order {
        box-sizing: border-box;
        width: 50px;
        height: 40px;
        background: #ffffff;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
    }

    .btn-filter {
        box-sizing: border-box;
        width: 50px;
        height: 40px;
        background: #ffffff;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
    }

    .btn-filter-red {
        box-sizing: border-box;
        width: 50px;
        height: 40px;
        left: 1830px;
        top: 21px;
        background: #9f3029;
        border: 1px solid #9f2d39;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        color: #ffffff;
    }

    .spinner-grow-static {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        background-color: currentColor;
        border-radius: 50%;
        opacity: .75;
    }

    a {
        text-decoration: none;
    }

    .btn-ativo {
        width: 40px;
        background-color: transparent;
        border-color: var(--bs-btn-hover-border-color);
    }

    .btn-ativo:hover {
        --bs-btn-border-color: #6c757d;
    }

    .select-block {
        background: #EEE;
        pointer-events: none;
        touch-action: none;
    }


</style>